import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TSP } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class DictionaryService {
  private readonly http = inject(HttpClient);

  public getProfileCustomFields(portalId: number): Observable<TSP.Internal.Dictionary.CustomField.Definition[]> {
    return this.http.get<TSP.Internal.Dictionary.CustomField.Definition[]>('/admin/dictionaries/profile-fields', {
      params: { portalId },
    });
  }
}
